(() => {
  'use strict';

  if (window.__studioCollectionV3Loaded) return;
  window.__studioCollectionV3Loaded = true;

  function updateSort(select) {
    const url = new URL(window.location.href);

    if (select.value) url.searchParams.set('sort_by', select.value);
    else url.searchParams.delete('sort_by');

    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function openDrawer(drawer) {
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('studio-collection-drawer-open');

    requestAnimationFrame(() => drawer.classList.add('is-visible'));
  }

  function closeDrawer(drawer) {
    if (!drawer) return;

    drawer.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('studio-collection-drawer-open');

    setTimeout(() => drawer.classList.remove('is-open'), 230);
  }

  document.addEventListener('change', (event) => {
    const sort = event.target.closest('[data-studio-cv3-sort]');
    if (sort) updateSort(sort);
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-studio-cv3-filter-open]');

    if (opener) {
      openDrawer(document.querySelector('[data-studio-cv3-drawer]'));
      return;
    }

    const closer = event.target.closest(
      '[data-studio-cv3-filter-close], [data-studio-cv3-overlay]'
    );

    if (closer) {
      closeDrawer(closer.closest('[data-studio-cv3-drawer]'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const drawer = document.querySelector('[data-studio-cv3-drawer].is-open');
    if (drawer) closeDrawer(drawer);
  });
})();
